/*
 * Copyright (c) 2018 Integral Agile, Inc. All rights reserved.
 *   Use of this file is subject to the terms and conditions defined in the file
 * 'LICENSE.txt'
 *   which is distributed in the root directory of this source code tree.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { throttle } from 'lodash';
import { IoCloseSharp } from 'react-icons/io5';
import { bindActionCreators } from 'redux';
import BurndownLegend from './burndownLegend';
import generateGraph from '../../utils/burndown';
import { cadenceBurndown } from '../../actions/cadenceActions';
import { onResizeDone } from '../../utils/browserHelpers';
import { closeModal } from '../../actions/modalActions';
import modalTypes from '../../constants/modalTypes';

class CadenceBurndown extends React.Component {
  constructor() {
    super();

    this.chart = null;

    this.state = {
      loading: true,
      resizing: false
    };

    this.setGraph = this.setGraph.bind(this);
  }

  componentDidMount() {
    if (this.props.graphData) {
      this.setGraph(this.props.graphData);
    } else {
      this.props.cadenceBurndown(this.props.cadence.id);
    }

    onResizeDone(
      true,
      'resizing-cadence-burndown',
      this.handleResize,
      this.stopResizing,
      300
    );
  }

  componentWillUnmount() {
    onResizeDone(false, 'resizing-cadence-burndown');
  }

  handleResize = throttle(() => {
    this.setState({ resizing: true });
  }, 100);

  stopResizing = () =>
    this.setState({ resizing: false }, () => {
      if (this.props.graphData) {
        this.setGraph(this.props.graphData);
      }
    });

  componentDidUpdate(prevProps) {
    if (prevProps.graphData !== this.props.graphData) {
      this.setGraph(this.props.graphData);
    }
  }

  setGraph(data = {}) {
    this.setState({ loading: false });
    this.chart = generateGraph(data);
  }

  render() {
    const { resizing } = this.state;
    return (
      <div
        className="detail-modal user-modal cadence-burndown"
        tabIndex="-1"
        role="dialog"
      >
        <div className="detail-dialog" role="document">
          <div className="profile-content modal-content">
            <div className="modal-header profile-header detail-header">
              <div className="col-sm-6">
                <h4 className="modal-title">Cadence Burndown</h4>
              </div>
              <div className="col-sm-6 detail-close">
                <button
                  type="button"
                  className="btn-close"
                  onClick={() =>
                    this.props.closeModal(
                      modalTypes.cadenceBurndown,
                      'cadenceBurndown'
                    )
                  }
                >
                  <IoCloseSharp size="2em" />
                </button>
              </div>
            </div>
            <div className="modal-body">
              <div className="row">
                <div className="col-sm-12 chart-container">
                  {this.state.loading && <div id="mini-loader" />}
                  {!resizing && (
                    <>
                      <div id="chart" />
                      <BurndownLegend burndown={this.props.graphData} />
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

CadenceBurndown.propTypes = {
  cadence: PropTypes.object,
  graphData: PropTypes.object,
  cadenceBurndown: PropTypes.func,
  closeModal: PropTypes.func
};

const mapStateToProps = (state) => ({
  cadence: state.cadenceReducer.cadence,
  graphData: state.cadenceReducer.burndownData
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      closeModal,
      cadenceBurndown
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(CadenceBurndown);
